var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKycUnauthorized = function SvgKycUnauthorized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.668 2.332c-3.11-3.11-8.226-3.11-11.336 0-3.11 3.11-3.11 8.226 0 11.336 3.11 3.11 8.226 3.11 11.336 0 3.11-3.11 3.11-8.126 0-11.336Z",
    fill: "#696F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.868 11.57 8.361 9.064 5.853 11.57c-.201.2-.502.2-.703 0-.2-.201-.2-.502 0-.703l2.508-2.507L5.15 5.853c-.2-.201-.2-.502 0-.703.201-.2.502-.2.703 0L8.36 7.658l2.507-2.508c.201-.2.502-.2.703 0 .2.201.2.502 0 .703L9.063 8.36l2.508 2.507c.2.201.2.502 0 .703-.201.2-.502.2-.703 0Z",
    fill: "#FFF"
  }))));
};
export default SvgKycUnauthorized;